define('order_wizard_cartitems_pickup_in_store_list.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_cartitems_pickup_in_store_list', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Packages.Collection\"></div>  ";
},"useData":true}, 'extensions/SuiteDB/CCAW_Theme/2.4.35/', 'extensions/SuiteDB/CCAW_Theme/2.4.35/', Handlebars);
});